import React from 'react';
import BaseButton from '../../buttons/BaseButton';
import { Tooltip } from '@progress/kendo-react-tooltip';

const SearchButton = ({ disabled, onClick, title, id, tooltip }) => (
  <Tooltip anchorElement='target' position='bottom'>
    {/* The span is necessary here so the tooltip can be shown with the buttons disabled */}
    <span title={tooltip}>
      <BaseButton
        type='button'
        className='button large white search-button'
        onClick={onClick}
        id={id}
        disabled={disabled}
        tooltip={tooltip}
      >
        {title}
      </BaseButton>
    </span>
  </Tooltip>
);

export default SearchButton;
